import React, { useEffect, useState } from "react";

// import KPIIndicatorModal from "./KPIIndicatorModal";
import { Modal, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";

import { baseUrlTraining } from "../../../http-common";
import {
  getAllTrainingName,
  getAssessmentQuestionsList,
  getMyTrainingList,
  getTrainingDocuments,
  getTrainingVideos,
} from "../../services/TrainingServices";
import Card from "./Card";
import CommonAssessmentTestModal from "./CommonAssessmentTestModal";
import CommonHeading from "../../../common/components/Custom Hooks/CommonHeading";

import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { errorAlert } from "../../../common/components/Toasts/CustomToasts";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import SearchBar from "./SearchBar";
import CardSkeleton from "./CardSkeleton";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import RadioField from "../../../common/components/FormFields/RadioField";
/****************** user actions configuration ******************/

const SunIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-5 h-5"
  >
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

const MoonIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-5 h-5"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const DarkModeToggle = ({ darkMode, toggleDarkMode }) => (
  <Tooltip title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}>
    {" "}
    <button
      onClick={toggleDarkMode}
      className={`
      flex items-center gap-2 px-2 py-2 rounded-full text-sm font-medium
      border transition-all duration-300 select-none
      ${
        darkMode
          ? "bg-slate-700 border-slate-500 text-amber-300 hover:bg-slate-600"
          : "bg-white border-gray-300 text-gray-700 hover:bg-gray-100 shadow-sm"
      }
    `}
    >
      {darkMode ? <SunIcon /> : <MoonIcon />}
      {/* <span>{darkMode ? "Light" : "Dark"}</span> */}
    </button>
  </Tooltip>
);

const userActions = [
  { id: 0, permission: "Edit", isAction: true },
  { id: 1, permission: "Delete", isAction: true },
  { id: 2, permission: "Create", isAction: false },
];

const TrainingsScreen = () => {
  const getUserInfo = JSON.parse(localStorage?.getItem("userInfo"));
  const { control } = useForm({
    defaultValues: {
      status: 3,
    },
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [trainingNameOptions, setTrainingNameOptions] = useState([]);
  const [count, setCount] = useState(0);
  const [filePreview, setFilePreview] = useState(null);
  const [openAsstTestModal, setOpenAsstTestModal] = useState(false);
  const [openPostAsstModal, setOpenPostAsstModal] = useState(false);
  const [assessmentQuestionsData, setAssessmentQuestionsData] = useState([]);
  const [testData, setTestData] = useState({
    preAssessment: null,
    postAssessment: null,
  });
  const [pdfUrl, setPdfUrl] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedDataForAssessment, setSelectedDataForAsessment] =
    useState(null);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [coursesData, setCoursesData] = useState([]);

  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("trainingDarkMode") === "true";
    } catch {
      return false;
    }
  });

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      try {
        localStorage.setItem("trainingDarkMode", String(!prev));
      } catch {}
      return !prev;
    });
  };
  //   let getTrainingDoc = async (doc) => {
  //   try {
  //     const response = await getTrainingDocuments(doc);

  //     const blob = response.data;
  //     const contentType = response.headers["content-type"];

  //     const url = URL.createObjectURL(blob);

  //     setFilePreview({
  //       url,
  //       fileType: contentType,
  //       name: doc,
  //     });

  //   } catch (error) {
  //     errorAlert(error?.message);
  //   }
  // };
  // let getTrainingDoc = (doc) => {
  //   getTrainingDocuments(doc)
  //     .then((response) => response.data)
  //     .then((res) => {
  //       const blob = new Blob([res], { type: "image/png" });
  //       const url = URL.createObjectURL(blob);
  //       setImageUrl(url);
  //       console.log(imageUrl, "imageUrl");
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // };
  let getTrainingDoc = async (doc, fileObj, onSuccess) => {
    setOpenBackdrop(true);

    try {
      const isVideo = fileObj?.fileType?.startsWith("video/");

      const response = isVideo
        ? await getTrainingVideos(doc)
        : await getTrainingDocuments(doc);
      const blob = response.data;
      // const contentType = response.headers["content-type"];
      if (!blob || blob.size === 0) {
        // errorAlert("File not found or empty");
        onSuccess?.(null);
        return;
      }
      setOpenBackdrop(false);

      const url = URL.createObjectURL(blob);
      if (fileObj?.fileType?.startsWith("video/")) {
        onSuccess?.(url);
        return;
      }
      if (fileObj?.fileType?.startsWith("image/")) {
        setImageUrl(url);
        setFilePreview(fileObj);
        return;
      }
      if (fileObj?.fileType == "application/pdf") {
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const pdfurl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfurl);
        setFilePreview(fileObj);
        return;
      }
    } catch (error) {
      onSuccess?.(null);
      errorAlert(error?.message);
      setOpenBackdrop(false);
    }
  };

  const renderFilePreview = () => {
    if (!filePreview) return null;

    const closeBtn = (
      <button
        className={`transition ${darkMode ? "text-gray-300 hover:text-white" : "text-gray-600 hover:text-black"}`}
        // onClick={() => setFilePreview(null)}
        onClick={() => {
          setFilePreview(null);
          if (pdfUrl) {
            URL.revokeObjectURL(pdfUrl);
            setPdfUrl(null);
          }
          if (imageUrl) {
            URL.revokeObjectURL(imageUrl);
            setImageUrl(null);
          }
        }}
      >
        <CloseModalIcon />
      </button>
    );

    if (filePreview?.fileType?.startsWith("image/")) {
      return (
        <div className="rounded-md p-1">
          <div className="flex justify-between">
            <p
              className={`text-sm font-semibold mb-2 ${darkMode ? "text-gray-200" : "text-gray-700"}`}
            >
              File Preview
            </p>
            {closeBtn}
          </div>
          <img
            src={imageUrl}
            alt={filePreview.name}
            className="w-full h-[70vh] object-contain rounded-md"
          />
          <p
            className={`text-xs mt-2 text-center ${darkMode ? "text-gray-400" : "text-gray-600"}`}
          >
            {filePreview.name}
          </p>
        </div>
      );
    } else if (filePreview?.fileType === "application/pdf") {
      return (
        <div className="rounded-md p-1">
          <div className="flex justify-between">
            <p
              className={`text-sm font-semibold mb-2 ${darkMode ? "text-gray-200" : "text-gray-700"}`}
            >
              PDF Preview
            </p>
            {closeBtn}
          </div>
          {/* <iframe
            // src={`${baseUrl.replace(/\/$/, "")}/trainings/${filePreview?.path?.replace(/^\//, "")}#toolbar=0&navpanes=0&scrollbar=0`}
            src={pdfUrl} //             className="w-full h-[70vh] rounded-md"
            title={filePreview?.fileName}
          /> */}
          <iframe
            src={pdfUrl}
            className="w-full h-[70vh] rounded-md"
            title={filePreview?.fileName}
          />
          <p
            className={`text-xs mt-2 text-center ${darkMode ? "text-gray-400" : "text-gray-600"}`}
          >
            {filePreview?.fileName}
          </p>
        </div>
      );
    }
    //  else if (
    //   filePreview?.fileType ===
    //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    // ) {
    //   const docUrl = `${mastersApi?.defaults?.baseURL}/${filePreview?.path}`;
    //   return (
    //     <div className="rounded-md p-3">
    //       <div className="flex justify-between">
    //         <p
    //           className={`text-sm font-semibold mb-2 ${darkMode ? "text-gray-200" : "text-gray-700"}`}
    //         >
    //           Document Preview
    //         </p>
    //         {closeBtn}
    //       </div>
    //       <iframe
    //         src={`${mastersApi?.defaults?.baseURL}/${filePreview?.path}`}
    //         className="w-full h-[70vh] rounded-md"
    //         title={filePreview?.fileName}
    //       />
    //       <p
    //         className={`text-xs mt-2 text-center ${darkMode ? "text-gray-400" : "text-gray-600"}`}
    //       >
    //         {filePreview?.fileName}
    //       </p>
    //     </div>
    //   );
    // }
    else {
      return (
        <div className="rounded-md p-3">
          <p
            className={`text-sm font-semibold mb-2 ${darkMode ? "text-gray-200" : "text-gray-700"}`}
          >
            File Preview
          </p>
          <div
            className={`flex flex-col items-center justify-center h-64 rounded-md ${darkMode ? "bg-slate-700" : "bg-gray-50"}`}
          >
            <p
              className={`text-sm font-medium ${darkMode ? "text-gray-200" : "text-gray-700"}`}
            >
              {filePreview.name}
            </p>
            <p
              className={`text-xs mt-1 ${darkMode ? "text-gray-400" : "text-gray-500"}`}
            >
              {(filePreview.size / (1024 * 1024)).toFixed(2)} MB
            </p>
          </div>
        </div>
      );
    }
  };

  const populateTable = (forPagination = false) => {
    showSpinner(true);
    if (getUserInfo || !getUserInfo) {
      // getMyTrainingList(getUserInfo?.employeeId)
      getMyTrainingList(getUserInfo?.empId)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 204) {
            const finalData = JSON.parse(res.result);
            setCoursesData(finalData);
            setCount(res.count);
          }
        })
        .catch(console.error)
        .finally(() => showSpinner(false));
    } else {
      showSpinner(false);
    }
  };

  useEffect(() => {
    populateTable();
  }, []);

  const getAssessmentQuestions = () => {
    setOpenPostModal(false);
    setOpenBackdrop(true);
    if (selectedDataForAssessment !== null) {
      const assessmentId =
        (selectedDataForAssessment?.ActiveStatus === "pre" &&
          selectedDataForAssessment?.pre_assessment_id) ||
        (selectedDataForAssessment?.ActiveStatus === "post" &&
          selectedDataForAssessment?.post_assessment_id);

      getAssessmentQuestionsList(
        selectedDataForAssessment?.trainingid,
        assessmentId,
      )
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 204) {
            const finalData = JSON.parse(res.result);
            setAssessmentQuestionsData(finalData);
            setOpenAsstTestModal(true);
            setCount(res?.count);
          }
        })
        .catch((error) => {
          errorAlert(error?.message);
        })
        .finally(() => setOpenBackdrop(false));
    }
  };

  const bg = darkMode ? "bg-slate-900" : "bg-gray-50";
  const modalBg = darkMode ? "bg-slate-800" : "bg-white";
  const headingC = darkMode ? "text-white" : "text-gray-900";
  const emptyC = darkMode ? "text-gray-400" : "text-gray-600";

  return (
    <div
      className={`px-2 my-1 w-full min-h-screen transition-colors duration-300 ${bg}`}
    >
      <div className="flex items-center justify-center pt-2 pb-1">
        <span className={headingC}>{CommonHeading("My Trainings")}</span>
      </div>

      <div className="gap-2 w-full items-center mt-2">
        <div
          className={`grid grid-cols-4 items-center gap-2 ${darkMode ? "[&_*]:!text-gray-100 [&_input]:!bg-slate-700 [&_input]:!border-slate-500 [&_.searchbar-wrapper]:!bg-slate-700" : ""}`}
        >
          {/* {!darkMode && ( */}
          <SearchBar
            sx={{ darkMode: darkMode }}
            name="SearchableSelect"
            placeholder="Training Name"
            isSearchable={true}
            searchIcon={true}
            dataArray={trainingNameOptions}
            handleInputChange={(e) => {
              const tempCheckChar =
                e !== null ? UseCheckConsecutiveCharacters(e) : true;
              if (e !== "" && tempCheckChar) {
                getAllTrainingName(e)
                  .then((response) =>
                    setTrainingNameOptions(response?.data?.result),
                  )
                  .catch(console?.error);
              } else {
                setTrainingNameOptions([]);
              }
            }}
            onChange={(e) => {
              setSearchString(e !== "" ? e : null);
            }}
            isClearable={true}
            clearSearchBar={true}
          />
          <div className="flex justify-start items-center col-span-2 ">
            {/* <fieldset> */}{" "}
            <RadioField
              name="status"
              // label="Status"
              control={control}
              dataArray={[
                { label: "All", id: 3 },
                { label: "Completed", id: 1 },
                { label: "Pending", id: 2 },
              ]}
            />
            {/* </fieldset> */}
            <CommonButton
              className="bg-customBlue text-white"
              searchIcon={true}
              onClick={
                () => {}
                // setListingObject({
                //   searchString: watch("SearchableSelect")?.label,
                //   page: page,
                //   size: rowsPerPage,
                //   searchId: watch("SearchableSelect")
                //     ? watch("SearchableSelect")?.id
                //     : null,
                //   menuId: null,
                //   departmentId: watchDepartment ? watchDepartment?.id : null,
                // })
              }
            />
          </div>

          {/* )} */}
          <span className="my-2 flex justify-end col-start-4 items-center">
            {" "}
            <DarkModeToggle
              darkMode={darkMode}
              toggleDarkMode={toggleDarkMode}
            />
          </span>
        </div>

        <div className="w-full grid grid-cols-1 gap-2 mt-2">
          {coursesData?.length > 0 && !spinner ? (
            coursesData.map((obj, idx) => (
              <div className="my-1" key={idx}>
                <Card
                  isPreAssessmentDone={
                    obj?.pre_assessment_required &&
                    obj?.pre_assessment_score === null
                      ? true
                      : false
                  }
                  getTrainingDoc={getTrainingDoc}
                  darkMode={darkMode}
                  selectedRow={selectedRow}
                  setSelectedRow={setSelectedRow}
                  getAssessmentQuestions={getAssessmentQuestions}
                  testData={testData}
                  course={obj}
                  renderFilePreview={renderFilePreview}
                  filePreview={filePreview}
                  setFilePreview={setFilePreview}
                  openPostAsstModal={openPostAsstModal}
                  setOpenPostAsstModal={setOpenPostAsstModal}
                  setOpenPostModal={setOpenPostModal}
                  selectedDataForAssessment={selectedDataForAssessment}
                  setSelectedDataForAsessment={setSelectedDataForAsessment}
                  openBackDrop={openBackDrop}
                />
              </div>
            ))
          ) : (
            <>
              {!spinner && (
                <div className="flex justify-center">
                  <h3
                    className={`flex justify-center mt-20 font-bold ${emptyC}`}
                  >
                    No Records Found...
                  </h3>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {spinner && <CardSkeleton darkMode={darkMode} />}

      {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}

      <Modal
        open={Boolean(filePreview)}
        onClose={() => setFilePreview(null)}
        aria-labelledby="file-preview-modal"
      >
        <div className="fixed inset-0 flex items-center justify-center bg-black/60">
          <div
            className={`w-[90%] md:w-[70%] rounded-xl p-2 relative ${modalBg}`}
          >
            {renderFilePreview()}
          </div>
        </div>
      </Modal>

      {openAsstTestModal && (
        <CommonAssessmentTestModal
          isDarkMode={darkMode}
          backendData={assessmentQuestionsData}
          open={openAsstTestModal}
          onClose={setOpenAsstTestModal}
          setTestData={setTestData}
          testData={testData}
          populateTable={populateTable}
          selectedDataForAssessment={selectedDataForAssessment}
          setSelectedDataForAsessment={setSelectedDataForAsessment}
        />
      )}

      {openPostModal && (
        <ConfirmationModal
          confirmationOpen={openPostModal}
          confirmationHandleClose={() => {
            setOpenPostModal(false);
            setSelectedDataForAsessment(null);
          }}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure you want to give the assessment test?"
          confirmationSubmitFunc={getAssessmentQuestions}
          confirmationButtonMsg="Yes"
        />
      )}
    </div>
  );
};

export default TrainingsScreen;
